import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';

export const ContactSupportButton = () => {
	const handleContactSupport = () => {
		const route = window.location.pathname;
		const positionAdminAuthToken = window.localStorage.getItem(
			'positionAdminAuthToken'
		);
		const candidateAuthToken =
			window.localStorage.getItem('candidateAuthToken');

		const body = encodeURIComponent(`Hello Brivio Support Team,

I need assistance with the Interviewing Portal.

Technical Details:
- Current Route: ${route}
- Position Admin Auth Token: ${positionAdminAuthToken || 'Not available'}
- Candidate Auth Token: ${candidateAuthToken || 'Not available'}

Please describe your issue below:
[Please describe your issue here]

Best regards`);

		window.open(
			`mailto:team@brivio.io?subject=Support Request for Interviewing Portal&body=${body}`,
			'_blank',
			'noopener,noreferrer'
		);
	};

	return (
		<div className="fixed bottom-6 right-6 z-50">
			<TooltipProvider>
				<Tooltip>
					<TooltipTrigger asChild>
						<Button
							onClick={handleContactSupport}
							size="lg"
							className="rounded-full w-10 h-10 shadow-lg hover:shadow-xl transition-shadow"
							aria-label="Contact Support"
						>
							<HelpCircle className="w-6 h-6" />
						</Button>
					</TooltipTrigger>
					<TooltipContent side="left" className="mb-2">
						<p>Contact Support</p>
						<p className="text-xs text-muted-foreground">team@brivio.io</p>
					</TooltipContent>
				</Tooltip>
			</TooltipProvider>
		</div>
	);
};
